import { fetchAuth } from "../../../shared/api/ApiService"
import { IAdmin, IAdminCreate, IAdminData, IAdminFinance, IAdminFinanceByTgAdmins, 
    IAdminLesson, IPayment, ITransactionsAdmin } from "../model/types"



class AdminService{
    async getAll(): Promise<IAdmin[]> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/admins')
        const {admins}: {admins: IAdmin[]} = await res.json()
        return admins
    }

    async get(id: number): Promise<IAdminData>{
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/admins/' + id)
        const {admin}: {admin: IAdminData} = await res.json()
        return admin
    }

    async delete(id: number){
        await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/admins/' + id, {
            method: "DELETE"
        })
    }

    private getFileNameFromContentDisposition(contentDisposition: string): string | null {
        const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
        if(utf8Match?.[1]){
            return decodeURIComponent(utf8Match[1].replace(/"/g, ''))
        }

        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i)
        return fileNameMatch?.[1] || null
    }

    async getFinance(from: string, to: string, admin_id?: number): Promise<IAdminFinance> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/finance', {
            method: "POST",
            body: JSON.stringify({
                from,
                to,
            })
        })
        const {data}: {data: IAdminFinance} = await res.json()
        return data
    }

    async downloadFinanceDetails(from: string, to: string, work_tg_ids: number[] = []): Promise<{blob: Blob, fileName: string}> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/finance/download', {
            method: "POST",
            body: JSON.stringify({
                from,
                to,
                work_tg_ids,
            })
        })

        const contentDisposition = res.headers.get('Content-Disposition') || ''
        const fileName = this.getFileNameFromContentDisposition(contentDisposition)
            || `finance_${from}_${to}.xlsx`

        return {
            blob: await res.blob(),
            fileName,
        }
    }

    async getFinanceByTgAdmins(from: string, to: string, admin_id: number, work_tg_ids: number[]): Promise<IAdminFinanceByTgAdmins> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/finance_by_tgs', {
            method: "POST",
            body: JSON.stringify({
                from,
                to,
                work_tg_ids,
                admin_id
            })
        })
        const {data}: {data: IAdminFinanceByTgAdmins} = await res.json()
        return data
    }

    async getTransactions(from: string, to: string): Promise<{transactions: ITransactionsAdmin[], transactions_count: number}> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/transactions', {
            method: 'POST',
            body: JSON.stringify({from, to})
        })
        const {transactions, transactions_count}: {transactions: ITransactionsAdmin[], transactions_count: number} = await res.json()
        return {transactions, transactions_count}
    }
    
    async create(admin: IAdminCreate){
        await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/admins', {
            method: "POST",
            body: JSON.stringify(admin)
        })
    }

    async getLessons(from: string, to: string){
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/lessons', {
            method: "POST",
            body: JSON.stringify({from, to})
        })
        const {lessons, lessons_count, total_hours}: {lessons: IAdminLesson[], lessons_count: number, total_hours: number} = await res.json()
        return {lessons, lessons_count, total_hours}
    }

    async getPayments(): Promise<IPayment[]> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/payments')
        const {payments}: {payments: IPayment[]} = await res.json()
        return payments
    }
}

export const adminService = new AdminService()
